module.exports = __webpack_public_path__ + "static/media/SWSCRC6-30.251c5202.mp3";